import { CardTemplate } from '../types';

export const drawCardOnCanvas = (
  canvas: HTMLCanvasElement, 
  template: CardTemplate, 
  data: Record<string, any>
) => {
  const ctx = canvas.getContext('2d');
  if (!ctx || !template.backgroundImage) return;

  const img = new Image();
  // CRITICAL: This allows the canvas to export data (download) even if image is from Firebase Storage
  img.crossOrigin = "Anonymous"; 
  img.src = template.backgroundImage;
  
  img.onload = () => {
    // Standardize canvas size or use image size
    canvas.width = img.width > 0 ? img.width : 1011; // Approx credit card ratio high res
    canvas.height = img.height > 0 ? img.height : 638;
    
    // Draw Background
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    // Draw Fields
    template.fields.forEach(field => {
      const value = data[field.key];
      
      // Check if value is a base64 image string
      if (typeof value === 'string' && value.startsWith('data:image')) {
          const photo = new Image();
          photo.src = value;
          photo.onload = () => {
              // Use 'fontSize' as the width for the image
              const targetWidth = field.fontSize > 30 ? field.fontSize : 150; // Default to 150 if size seems like text size
              const targetHeight = photo.height * (targetWidth / photo.width);
              ctx.drawImage(photo, field.x, field.y, targetWidth, targetHeight);
          };
      } else {
          // Normal Text Drawing
          ctx.font = `bold ${field.fontSize}px Arial`;
          ctx.fillStyle = field.color;
          ctx.fillText(String(value || ''), field.x, field.y);
      }
    });
  };

  img.onerror = (e) => {
    console.error("Failed to load card template image", e);
  };
};

export const downloadCanvas = (canvas: HTMLCanvasElement, filename: string) => {
  try {
    const link = document.createElement('a');
    link.download = filename;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } catch (e) {
    console.error("Download failed, likely due to CORS:", e);
    alert("Cannot download: Security error. Please ensure the template image is loaded correctly.");
  }
};

export const AVAILABLE_FIELDS = [
  { key: 'serialNo', label: 'ക്രമനമ്പർ (Serial No)' },
  { key: 'headName', label: 'കുടുംബ നാഥൻ / നാഥ' },
  { key: 'houseName', label: 'വീട്ട് പേര് (House Name)' },
  { key: 'wardNo', label: 'വാർഡ് (Ward)' },
  { key: 'houseNo', label: 'വീട്ട് നമ്പർ (House No)' },
  { key: 'phone', label: 'ഫോൺ (Phone)' },
  { key: 'post', label: 'പോസ്റ്റ് (Post)' },
  { key: 'village', label: 'വില്ലജ് (Village)' },
  { key: 'housePhoto', label: 'ഫോട്ടോ (Photo)' },
];